<template>
  <div>
    <loan-ebarimts-list-filters
      :loan-ebarimt-filter.sync="loanEbarimtFilter"
    />

    <!-- Detail Modal -->
    <loan-ebarimt-detail-modal
      :visible.sync="isDetailModalVisible"
      :entry-id="selectedEntryId"
    />

    <!-- Send Confirm Modal -->
    <b-modal
      id="send-loan-ebarimt-confirm-modal"
      title="И-баримт илгээх"
      ok-variant="success"
      ok-title="Илгээх"
      cancel-title="Болих"
      centered
      :ok-disabled="isSending"
      @ok.prevent="handleSend"
    >
      <p v-if="selectedSendEntry">
        Та <strong>{{ selectedSendEntry.due_date }}</strong> огнооны, харилцагч <strong>{{ selectedSendEntry.customer_id }}</strong>-н бүртгэлийг И-баримтын системд илгээхдээ итгэлтэй байна уу?
      </p>
    </b-modal>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Нэг хуудсанд</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label> бичлэг харуулах</label>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refReportDataTable"
        class="position-relative"
        :items="fetchLoanEbarimtData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Trigger Type -->
        <template #cell(trigger_type)="data">
          {{ resolveTriggerTypeLabel(data.item.trigger_type) }}
        </template>

        <!-- Column: Total Amount -->
        <template #cell(total_amount)="data">
          <div class="text-nowrap">
            {{ formatCurrency(data.item.total_amount) }}
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.status)}`"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex align-items-center text-nowrap">
            <b-button
              v-b-tooltip.hover
              title="Дэлгэрэнгүй"
              variant="flat-primary"
              size="sm"
              class="btn-icon"
              @click="showDetail(data.item)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
              v-if="data.item.status === 'PENDING'"
              variant="success"
              size="sm"
              class="ml-1 text-nowrap"
              @click="confirmSend(data.item)"
            >
              <feather-icon icon="SendIcon" class="mr-50" />
              <span>Илгээх</span>
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Нийт {{ dataMeta.of }}-н {{ dataMeta.from }} - {{ dataMeta.to }} бичлэгийг харуулж байна</span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalEntries"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge, BPagination, BModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, getCurrentInstance } from '@vue/composition-api'
import { formatCurrency } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LoanEbarimtsListFilters from './LoanEbarimtsListFilters.vue'
import LoanEbarimtDetailModal from './LoanEbarimtDetailModal.vue'
import useLoanEbarimtsList from './useLoanEbarimtsList'
import loanEbarimtStoreModule from '../loanEbarimtStoreModule'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    LoanEbarimtsListFilters,
    LoanEbarimtDetailModal,

    BCard,
    BModal,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,

    vSelect,
  },
  setup() {
    const toast = useToast()
    const root = getCurrentInstance().proxy
    const LOAN_EBARIMT_APP_STORE_MODULE_NAME = 'app-loan-ebarimt'

    // Register module
    if (!store.hasModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME)) store.registerModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME, loanEbarimtStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME)) store.unregisterModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME)
    })

    const isDetailModalVisible = ref(false)
    const selectedEntryId = ref(null)

    const showDetail = item => {
      selectedEntryId.value = item.id
      isDetailModalVisible.value = true
    }

    const {
      fetchLoanEbarimtData,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReportDataTable,
      refetchData,

      resolveStatusVariant,
      resolveTriggerTypeLabel,

      loanEbarimtFilter,
    } = useLoanEbarimtsList()

    const selectedSendEntry = ref(null)
    const isSending = ref(false)

    const confirmSend = item => {
      selectedSendEntry.value = item
      root.$bvModal.show('send-loan-ebarimt-confirm-modal')
    }

    const handleSend = () => {
      const entry = selectedSendEntry.value
      if (!entry) return
      isSending.value = true
      store
        .dispatch('app-loan-ebarimt/sendLoanEbarimtRegistry', {
          due_date_from: entry.due_date,
          due_date_to: entry.due_date,
          entry_id: entry.id,
          force: true,
        })
        .then(response => {
          const { success, failed, skipped } = response.data
          toast({
            component: ToastificationContent,
            props: {
              title: `Илгээлээ: амжилттай ${success}, амжилтгүй ${failed}, алгассан ${skipped}`,
              icon: failed ? 'AlertTriangleIcon' : 'CheckIcon',
              variant: failed ? 'warning' : 'success',
            },
          })
          root.$bvModal.hide('send-loan-ebarimt-confirm-modal')
          refetchData()
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'И-баримт илгээхэд алдаа гарлаа',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          isSending.value = false
        })
    }

    return {
      // Detail Modal
      isDetailModalVisible,
      selectedEntryId,
      showDetail,

      // Send
      selectedSendEntry,
      isSending,
      confirmSend,
      handleSend,

      fetchLoanEbarimtData,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReportDataTable,
      refetchData,
      formatCurrency,

      resolveStatusVariant,
      resolveTriggerTypeLabel,

      loanEbarimtFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
